import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import Button from "@material-ui/core/Button";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import AppUserRoleAction from "../../../redux/adminPanel/appUserRole/AppUserRoleAction";
import {
  ApAppuserGetList_Url,
  ApProfileMsGetList_Url,
} from "../../../provider/ServiceUrl";
import PtsButton from "../../givBee/buttons/PtsButton";
import Utils from "../../../provider/Utils";
import AdminPaginationRowAction from "../../../redux/adminPanel/paginationRow/AdminPaginationRowAction";

class AdminAppUserList extends Component {
  header = store.getState().adminHeader.adminHeader;
  adminUserState = store.getState().applicationState.adminUserState;
  adminPaginationState = store.getState().applicationState.usersState;
  adminUserStateDetails = {};
  adminPaginationStateDetails = {};
  title = "Admin User List";
  breadCrumb = [{ pageid: "", uiname: "Admin User List" }];
  constructor() {
    super();
    if (this.adminUserState) {
      this.adminUserStateDetails = Object.getOwnPropertyNames(
        this.adminUserState
      );
    }
    if (this.adminPaginationState) {
      this.adminPaginationStateDetails = Object.getOwnPropertyNames(
        this.adminPaginationState
      );
    }
    if (this.adminUserStateDetails.length > 0) {
      this.state = {
        initialPage: this.adminUserState.initialPage,
        pageSize: this.adminUserState.pageSize,
        searchText: this.adminUserState.searchText,
        appUserList: [],
        isPaging: false,
        render: false,
        getCreatePermission: false,
        appUserId: this.adminUserState.appUserId,
      };
    } else {
      this.state = {
        initialPage: 0,
        pageSize:
          this.adminPaginationStateDetails?.length > 0
            ? this.adminPaginationState?.pageSize
            : 20,
        appUserList: [],
        isPaging: false,
        render: false,
        getCreatePermission: false,
        appUserId: "",
        searchText: "",
      };
    }
    this.getAppUserList();
  }

  componentDidMount() {
    this.getUserRoleList();
  }

  async getUserRoleList() {
    const postObject = {
      header: this.header,
    };
    await AdminFetchServerData.callPostService(
      ApProfileMsGetList_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let profileList = output.data.profileList;
        store.dispatch(AppUserRoleAction.setAppUserRole(profileList));
        this.setState({
          render: true,
          profileList: profileList,
        });
      }
    });
  }

  getAppUserList() {
    const postObject = {
      header: this.header,
    };

    AdminFetchServerData.callPostService(ApAppuserGetList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let appUserList = output.data.appusers;
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getCreatePermission = getPermission[1];
          let isPaging = false;
          if (appUserList.length > 20) {
            isPaging = true;
          }

          for (const user of appUserList) {
            user.phone = Utils.viewPhoneNumberFormate(user.phone);
          }

          this.setState({
            render: true,
            isPaging: isPaging,
            appUserList: appUserList,
            initialPage: this.state.initialPage,
            getCreatePermission: getCreatePermission,
          });
        }
      }
    );
  }

  addUser() {
    this.props.navigate("/appUser", {
      state: {
        action: "create",
      },
    });
  }

  toUserDetails(e, data) {
    let adminUserState = {
      appUserId: data.id,
      searchText: this.state.searchText,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ adminUserState })
    );
    this.props.navigate("/appUser", {
      state: {
        action: "view",
        appUserId: data.id,
      },
    });
  }
  handleMaterialTablePageChange(page, pageSize) {
    let usersState = {
      initialPage: page,
      pageSize: pageSize,
    };
    store.dispatch(
      AdminPaginationRowAction.setUsersPaginationState({ usersState })
    );
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  handleSearchChange(searchText) {
    let adminUserState = {
      appUserId: this.state.appUserId,
      searchText: searchText,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ adminUserState })
    );
    this.setState({ searchText: searchText });
  }

  accountLockToBackend(data) {
    const postObject = {
      header: this.header,
      appuser: {
        id: data.id,
      },
    };
    AdminFetchServerData.callPostService(
      "/apAppuserms/unlockUser",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        this.getAppUserList();
      }
    });
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
          isSearchText={this.state.searchText !== ""}
        />
        <div style={{ maxWidth: "100%" }}>
          <MaterialTable
            title=""
            onRowClick={(event, rowData) => {
              this.toUserDetails(event, rowData);
              event.stopPropagation();
            }}
            icons={UiUtils.getMaterialTableIcons()}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 className="dataNotAvailable">Please add user</h5>
                ),
              },
            }}
            columns={[
              {
                title: "#",
                render: (rowData) => rowData.tableData.id + 1,
                width: "5%",
                align: "left",
                cellStyle: {
                  width: "6%",
                },
              },
              {
                title: "Name",
                field: "name",
                cellStyle: {
                  width: "18%",
                },
              },
              {
                title: "Email",
                field: "email",
                cellStyle: {
                  width: "20%",
                  textTransform: "lowercase",
                },
              },
              {
                title: "Phone",
                field: "phone",
                cellStyle: {
                  width: "15%",
                },
              },
              {
                title: "Profile",
                field: "profile",
                cellStyle: {
                  width: "15%",
                },
              },
              {
                title: "Status",
                field: "status",
              },
              {
                title: "Actions",
                sorting: false,
                disableClick: true,
                render: (rowData) =>
                  rowData.accountLocked && (
                    <Button
                      variant="contained"
                      size="small"
                      style={{
                        background: "#d3d8de",
                        color: "#353538",
                        textTransform: "capitalize",
                      }}
                      startIcon={<i class="fa-solid fa-unlock-keyhole"></i>}
                      onClick={() => this.accountLockToBackend(rowData)}
                    >
                      Unlock
                    </Button>
                  ),
                cellStyle: {
                  width: "10%",
                  cursor: "pointer",
                },
              },
            ]}
            data={this.state.appUserList}
            options={{
              sorting: true,
              actionsColumnIndex: -1,
              searchText: this.state.searchText,
              initialPage: this.state.initialPage,
              pageSize: this.state.pageSize,
              pageSizeOptions: [5, 10, 20, 50, 100],
              paging: this.state.isPaging,
              headerStyle: {
                backgroundColor: "#37517e",
                fontWeight: "bold",
                color: "#ffff",
                align: "left",
              },
              rowStyle: (rowData) => ({
                backgroundColor:
                  rowData.id === this.state.appUserId ? "#e6effc" : "",
                height: "3em",
                textTransform: "capitalize",
              }),
            }}
            onSearchChange={(searchText) => {
              this.handleSearchChange(searchText);
            }}
            onChangePage={(page, pageSize) => {
              this.handleMaterialTablePageChange(page, pageSize);
            }}
            actions={[
              {
                icon: () =>
                  this.state.getCreatePermission && (
                    <PtsButton btnName="Add User" type="submit" />
                  ),
                isFreeAction: true,
                onClick: () => {
                  this.addUser();
                }
              },
            ]}
          />
        </div>
      </>
    );
  }
}
export default withRouter(AdminAppUserList);
